import { track } from 'src/lib/analytics/utils';
import { requestMiniAppToSConsent } from 'src/lib/gcinstant';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { Feature } from 'src/replicant/analytics';
import {
  TOS_PUZZLE_PINCH_REWARD_MOVES,
  shouldShowTosPuzzlePinchNudge,
} from './tosPuzzlePinch.utils';

type TosPuzzlePinchAnalytics = {
  totalObstaclesRemaining: number;
  ratioObstaclesRemaining: number;
  remainingMoves: number;
  limitMoves?: number;
};

type HandleTosPuzzlePinchNudgeOpts = {
  level: number;
  moves: number;
  price: number;
  continues: number;
  pinchAnalytics: TosPuzzlePinchAnalytics;
  levelVersioningProps: Record<string, unknown>;
  continueViaTos: () => Promise<void>;
  purchaseContinue: () => Promise<void>;
};

type HandleTosPuzzlePinchNudgeResult = {
  handled: boolean;
  success: boolean;
  consumedFirstPinch: boolean;
};

export async function handleTosPuzzlePinchNudge(
  opts: HandleTosPuzzlePinchNudgeOpts,
): Promise<HandleTosPuzzlePinchNudgeResult> {
  if (!shouldShowTosPuzzlePinchNudge()) {
    return {
      handled: false,
      success: false,
      consumedFirstPinch: false,
    };
  }

  const tosNudgeAnalytics = {
    level: opts.level,
    totalObstaclesRemaining: opts.pinchAnalytics.totalObstaclesRemaining,
    ratioObstaclesRemaining: opts.pinchAnalytics.ratioObstaclesRemaining,
    remainingMoves: opts.pinchAnalytics.remainingMoves,
    limitMoves: opts.pinchAnalytics.limitMoves ?? 0,
    ...opts.levelVersioningProps,
  };

  track('PuzzlePinchPurchaseTOSView', tosNudgeAnalytics);

  const result = await openPopupPromise('popupTosPuzzlePinchNudge', {
    amount: opts.moves,
    continues: opts.continues,
    price: opts.price,
    rewardMoves: TOS_PUZZLE_PINCH_REWARD_MOVES,
  });

  if (!result) {
    return {
      handled: true,
      success: false,
      consumedFirstPinch: true,
    };
  }

  if (result.acceptTos) {
    track('PuzzlePinchPurchaseTOSContinue', tosNudgeAnalytics);

    const accepted = await requestMiniAppToSConsent({
      feature: Feature.CONTINUE._,
      subFeature: Feature.CONTINUE.TOS,
    });

    if (accepted) {
      await opts.continueViaTos();
      return {
        handled: true,
        success: true,
        consumedFirstPinch: true,
      };
    }
  } else if (result.purchase) {
    await opts.purchaseContinue();
    return {
      handled: true,
      success: true,
      consumedFirstPinch: true,
    };
  }

  return {
    handled: false,
    success: false,
    consumedFirstPinch: true,
  };
}
